export const state = () => ({
    fileUrl: '/standalonfile',
    webUrl: `/web/bbs`,
    baseWebUrl: `/web`,
    // 云咨空间采购文件编制地址
    yzkjTemplate: process.env.NODE_ENV === 'development' ? 'https://192.168.1.173:10006' : 'https://www.yunzikongjian.com/template',
})

export const mutations = {
    
}

export const getters = {
    
}
